import { LOADING, LOADING_COMPLEMENT, LOAD_PERIODS, LOADING_PERIOD } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
    switch (action.type) {
            case LOADING_COMPLEMENT:               
                return {
                ...state,
                afp: action.payload.afps,
                isapre: action.payload.isapres,
                region: action.payload.regions
            }
            case LOAD_PERIODS:
                return {
                    ...state, 
                    periods: action.payload
                }
            case LOADING_PERIOD:
                return {
                    ...state, 
                    loadPeriod: !state.loadPeriod
                }
           case LOADING:               
               return {
                   ...state,
                   loading: !state.loading
               }
        default:
            return state;
    }
}